(ns ui.dark-launch
  "Features that are deployed but not reachable for users: a switch in
   the browser's localStorage that a DevTools console function sets
   (see `ui.hyperframes-templates.devtools`).
   The UI entry of such a feature renders only while its switch is on.
   Not a feature flag: no per-organization state, nothing to clean up;
   when the feature launches, the entry stops asking and the console
   function goes away.")

(defn storage-key
  [feature]
  (str "storrito." (name feature)))

(defn enabled?
  [feature]
  (try
    (= "on" (.getItem js/localStorage (storage-key feature)))
    (catch :default _
      false)))

(defn enable!
  "Switches the feature on for this browser and reloads the page."
  [feature]
  (.setItem js/localStorage (storage-key feature) "on")
  (.reload js/location))

(defn disable!
  [feature]
  (.removeItem js/localStorage (storage-key feature))
  (.reload js/location))
